<!--发起调拨页面-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >
    <div ref="print1" style="width: 850px;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <p v-show="uname" style="color: red"><span>操作人：</span>{{uname}}<span>正在操作</span>
        <span @click="unlock" style="color: blue;cursor: pointer;">&nbsp;解除锁定</span>
      </p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="print-table">
        <tr class="noborder" style="height: 26px">
          <td align="right" width="60">发&nbsp;&nbsp;货&nbsp;&nbsp;仓：</td>
          <td width="180">
            <el-select v-model="cangkucode" placeholder="请选择" size="mini" @change="changesend">
              <el-option
                v-for="item in jxcstoreDatasend"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right" width="80">地&nbsp;&nbsp;&nbsp;址：</td>
          <td>{{addresssend!=null?addresssend:""}}</td>
          <td align="right" width="60">电&nbsp;&nbsp;&nbsp;话：</td>
          <td width="140">{{linktelsend!=null ?linktelsend:" "}}
          </td>
        </tr>
        <tr class="noborder" style="height: 26px">
          <td align="right" width="60">收&nbsp;&nbsp;货&nbsp;&nbsp;仓：</td>
          <td width="140">
            <el-select v-model="cangkucode2" placeholder="请选择" size="mini" @change="changereceive" filterable >
              <el-option
                v-for="item in jxcstoreDatareceive"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right" width="80">地&nbsp;&nbsp;&nbsp;址：</td>
          <td width="220">{{addressreceive!=null?addressreceive:""}}</td>
          <td align="right" width="60">电&nbsp;&nbsp;&nbsp;话：</td>
          <td width="140">{{linktelreceive!=null ? linktelreceive:" "}}</td>
        </tr>
        <tr class="noborder" style="height: 26px" v-if="jinjia!=80&&isRouterAlive">
          <td align="right">商&nbsp;&nbsp;品&nbsp;&nbsp;名：</td>
          <td colspan="2">
            <CommonTree ref="treeSeed" :inputSize="'mini'" :defineDataSource="true" @bindData="bindData"
                        :isShowCheckBox="false" :treeWidth="600"
                        :treeHeight="400" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>
          </td>
          <td colspan="3">
            <el-button type="warning" @click="initnum" size="mini">一键补货</el-button>
            <el-button type="warning" @click="loadFromBuy" size="mini">从采购单导入</el-button>
            <el-button type="warning" @click="loadFromexcel" size="mini">从EXCEL导入</el-button>
            <a href="./static/file/镜片导入格式.xls">下载模板</a>
            <input type="file" ref="fileupload1" style="display: none;" @change="change1($event)"/>
            <!--<span>编码：{{form.seedcode}}</span>-->
          </td>
          <!--<td align="right">时&nbsp;&nbsp;&nbsp;间:</td>-->
          <!--<td>-->
          <!--</td>-->
        </tr>
        <tr class="noborder" style="height: 26px" v-if="jinjia==80&&isRouterAlive">
          <td align="right">类&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</td>
          <td colspan="2">
            <CommonTree ref="treeSeedleibie" :inputSize="'mini'" :defineDataSource="true" @bindData="jinjiabindData"
                        :treeWidth="550" style="width: 150px;display: inline-block"
                        :onlyShowGroupType="true" :needTopNode="false" :onlySelectChild="false"
                        :treeHeight="400" :searchText="form.seedname"
                        @check="jingjiachecktree1"></CommonTree>
            <el-button type="primary" @click="addFrame" size="mini">增加</el-button>
            <el-button size="mini" type="success" @click.stop.prevent="showGoodDetailSel()">选择
            </el-button>
          </td>
          <td>
            <!--<el-button type="primary" @click="initnum" size="mini">一键补货</el-button>-->
            <el-button type="primary" @click="loadFromBuy" size="mini">导入</el-button>
            <el-input style="width: 150px" size="mini" v-model="goodsbarcode"
                      @change="getBarCode()" placeholder="扫唯一码"
                      onfocus="this.select()"></el-input>
            <!--<span>编码：{{form.seedcode}}</span>-->
          </td>
          <td align="right">时&nbsp;&nbsp;&nbsp;间：</td>
          <td>
          </td>
        </tr>
        <tr class="noborder" style="height: 26px;display: none" v-if="false">
          <td align="right">物&nbsp;&nbsp;&nbsp;流：</td>
          <td>
            <el-select v-model="logisticsco" placeholder="请选择" size="mini">
              <el-option
                v-for="item in parameterData"
                :key="item.value"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </td>
          <td align="right">单&nbsp;&nbsp;&nbsp;号：</td>
          <td>
            <el-input v-model="logisticsnum" auto-complete="off" required="true" size="mini"  style="width: 180px;" placeholder="请填写发货单号"></el-input>
          </td>
        </tr>
        <tr v-if="jinjia==80||isyinxin">
          <td colspan="6" style="text-align: right">总数:{{totalnumber}}</td>
        </tr>
        <tr class="noborder" v-show="showerweitable">
          <td colspan="6"><!--隐形调拨-->
            <el-table
              :data="tableData" v-if="isyinxin"
              :height="tableHeight(300)"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>
              <el-table-column
                prop="certorg" :show-overflow-tooltip="true"
                label="厂家"
                align="left" width="100"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="certno" :show-overflow-tooltip="true"
                label="注册证号"
                align="left" width="160"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="batchno" :show-overflow-tooltip="true"
                label="批次号"
                align="left" width="120"
                header-align="center">

              </el-table-column>
              <el-table-column
                prop="endtime" :show-overflow-tooltip="true"
                label="失效日期"
                align="left"  width="100"
                header-align="center">
                <template slot-scope="scope">
                  {{scope.row.endtime?scope.row.endtime.split(' ')[0]:''}}
                </template>
              </el-table-column>
              <el-table-column
                prop="Y"
                label="球镜"
                align="left"
                width="70"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="X"
                label="柱镜"
                align="left"
                width="70"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="P"
                label="库存"
                align="center"
                width="70"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="调拨数量"
                align="center"
                width="90"
                header-align="center">
                <template slot-scope="scope">
                  <el-input-number :controls="false" style="width: 100%" :min="0" :max="scope.row.P" size="small" v-model="scope.row.totalnumber"
                                   :ref='scope.row.id'
                                   onfocus="this.select()"
                                   @change="totalNumber"></el-input-number>
                </template>
              </el-table-column>
              <!--<el-table-column label="操作" align="center" width="100">-->
                <!--<template slot-scope="scope">-->
                  <!--<el-button size="mini" type="danger"-->
                             <!--@click="handleDelete(scope.$index, scope.row)">删除-->
                  <!--</el-button>-->
                <!--</template>-->
              <!--</el-table-column>-->
            </el-table>
            <TwoDimensionalTable ref="referweibiao" v-else :precision="0" :cutHeight="300" :erweitable="erweitable" :topInfoData="storeinfo"></TwoDimensionalTable>
          </td>
        </tr>
        <tr v-show="showzuoyoutable">
          <td colspan="6" style="border:none">
            <el-col :span="2" style="text-align: right">右眼：</el-col>
            <el-col :span="6">
              <TwoDimensionalTable ref="referweibiaoright" :precision="0" :cutHeight="311" :erweitable="erweitableright"
                                   :topInfoData="storeinforight"></TwoDimensionalTable>
            </el-col>
            <el-col :span="2" style="text-align: right">左眼：</el-col>
            <el-col :span="6">
              <TwoDimensionalTable ref="referweibiaoleft" :precision="0" :cutHeight="311" :erweitable="erweitableleft"
                                   :topInfoData="storeinfoleft"></TwoDimensionalTable>
            </el-col>
          </td>
        </tr>
        <tr v-show="shownumber">
          <td align="right">数&nbsp;&nbsp;&nbsp;量：</td>
          <td style="margin-bottom: 10px;margin-top: 10px">
            <el-input-number :controls="false" style="width: 100%" size="small" v-model="totalnumber" onfocus="this.select()"></el-input-number>
          </td>
        </tr>

        <tr class="noborder" v-if="jinjia==80">
          <td colspan="6">
            <el-table
              :data="tableData"
              :height="tableHeight(300)"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>

              <el-table-column
                prop="seedcode" :show-overflow-tooltip="true"
                label="编码"
                align="left"
                width="100"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="seedname" :show-overflow-tooltip="true"
                label="名称"
                align="left"
                header-align="center">
              </el-table-column>
              <!--<el-table-column-->
                <!--prop="costprice" :show-overflow-tooltip="true"-->
                <!--label="零售价"-->
                <!--align="right"-->
                <!--width="80"-->
                <!--header-align="center">-->
              <!--</el-table-column>-->
              <el-table-column
                prop="model" :show-overflow-tooltip="true"
                label="型号"
                align="left"
                width="100"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="color"
                label="色号" :show-overflow-tooltip="true"
                align="left"
                width="100"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="数量"
                align="center"
                width="90"
                header-align="center">
                <template slot-scope="scope">
                  <el-input-number :controls="false" style="width: 100%" size="small" v-model="scope.row.totalnumber"
                            :ref='scope.row.id'
                            onfocus="this.select()"
                            @keyup.enter.native="validateCounts(scope.row,scope.$index, $event)"
                            @keyup.down.native="validateCounts(scope.row,scope.$index, $event)"
                            @keyup.up.native="validateCounts(scope.row,scope.$index, $event)"
                            @change="totalNumber"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column
                prop="barcodes"
                label="条码"
                align="left"
                header-align="center">
                <template slot-scope="scope">
                  <div v-for="item in scope.row.barcodes" :key="item.c">
                    {{item.c}}<i class="el-icon-close" style="cursor: pointer" @click="clearBar(item.c,scope.row)"></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger"
                             @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </td>
        </tr>
        <tr class="noborder">
          <td>说&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="6">
            <textarea style="width: 100%;height: 60px" v-model="remark"></textarea>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :loading="loading" v-if="lock">{{buttonname}}</el-button>
      <el-button @click="createBarcode" :loading="loading" v-if="jinjia==80" icon="el-icon-printer" size="mini">打印条码</el-button>
    </div>
    <BatchBuyFormProperties ref="batchBuyFormProperties" @afterSelectCode="afterSelectCode"></BatchBuyFormProperties>
    <MakeInventoryFrameAdd ref="MakeInventoryFrameAdd" @afterSelect="afterSelectADD"></MakeInventoryFrameAdd>

  </el-dialog>
</template>
<script>
  import {sortByKey} from '@/api/dateUtil';
  import {getJxcformdetailCost} from '@/api/set/csagreement';
  import {getRemark} from '@/plugin/ordercommon'
  import {listgoodsframe, getGoodsTree} from '@/api/set/jxcgooddetail';
  import {getPrice} from '@/api/set/goodsprice';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {getGoodsNeedBuy, getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import BatchBuyFormProperties from '@/components/testorder/buyagreement/BatchBuyFormProperties'
  import {getDetail} from '@/api/set/allocation';
  import {getDetail as barcodeDetail,batchSave} from '@/api/set/jxcstoregoodsbarcode';
  import {getListData as listCert} from '@/api/set/certmanage'
  import {
    getCstagreementListDataNew,
    cstagreementDeleteData,
    cstagreementUpdateData,
    buyodersavedetail, jxcstorelist, getpcustomerserial
  } from '@/api/set/csagreement';

  import {getListData} from '@/api/set/jxcstore'
  import {getListDatabyinpd, getListDataall} from '@/api/set/jxcstore';
  import {saveData} from '@/api/set/allocation';
  import {getParameterDetail} from '@/api/set/parameter';
  import {saveData as logsaveData, getListData as logListData, lockremove} from '@/api/set/handlelog';
  import {createGoodsbarcode} from '@/api/set/jxcgoodsbarcode';
  import {barcodePrint} from '@/api/file';
  import MakeInventoryFrameAdd from './MakeInventoryFrameAdd';

  export default {
    name: 'AllocationEditNew',
    data() {
      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        buttonname: '',
        userInfoModel: {},
        loading: false,
        book: {XStart: 0, XEnd: 0, XSpace: 0, YStart: 0, YEnd: 0, YSpace: 0, BookContent: []},
        erweitable: [],//二维表
        shownumber:false,
        erweitableleft: [],//左眼二维表
        erweitableright: [],//右眼二维表
        costpricebook: {},
        dialogFormVisible: false,
        title: "",
        BookContent: [],
        BookContentLeft: [],
        BookContentRight: [],
        index: -99,
        seedgoods: [],
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        minyear: yearnow,
        minmonth: monthnow,
        goodsbarcode:'',
        maxyear: '',
        maxmonth: '',
        remark: '',
        cangkucodes: [],
        isyinxin:false,
        unitguid: '',
        jxcstoreDatareceive: [],
        jxcstoreDatasend: [],
        cangkucode: '',
        cangkuname: '',
        cangkucode2: '',
        cangkuname2: '',
        addresssend: '',
        linktelsend: '',
        addressreceive: '',
        linktelreceive: '',
        tableData1: [],
        tableData: [],//镜架使用
        column: [],
        filltemplate: '',
        controlData: '',
        showtitle1: "none",
        showzuoyoutable: false,
        showerweitable: false,
        logisticsco: '',
        logisticsnum: '',
        seedinfo: '',
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          erpserial: "",
        },
        isupdate: false,
        updatecz: 0,
        parameterData: [],
        categorycode: '',
        storeinfo: [],//库存信息
        storeinforight: [],//右库存信息
        storeinfoleft: [],//左库存信息
        independentserial: '',//仓库对应的核算部门
        lock: true,//锁定订单
        uname: '',//正在操作的人
        jinjia: '',//镜架调拨
        seedcodeData: [],//选择类别后的商品
        totalnumber: 0,//镜架 调拨总数
        isRouterAlive: false,
      }

    },
    methods: {
      checkCanSelect() {
        if (this.cangkucode == this.cangkucode2) {
          this.error('发货仓、收货仓不能选同一个！')
          return false;
        }

        if (this.form.seedcode && this.form.seedcode.length >= 9) {
          return true;
        } else {
          this.error('请选择品牌或系列！')
          return false;
        }
      },
      addFrame(){
        if (this.checkCanSelect()) {
          this.$refs.MakeInventoryFrameAdd.show(this.seedcodeData,
            {cangkucode:this.cangkucode,cangkuname:this.cangkuname,cangkucode2:this.cangkucode2,cangkuname2:this.cangkuname2})
        }
      },
      padleft(ret,width,padChar) {
        while (ret.length < width) {
          ret = padChar + ret;
        }
        return ret;
      },
      createBarcode() {

        var number = 0;
        for (let i in this.tableData) {
          var tn = this.tableData[i].totalnumber | 0;
          var scancount = this.tableData[i].barcodes.length;

          if (tn <= 0) {
            this.$message({message: '数量必须大于0！', type: 'error'})
            return;
          }
          if (tn > scancount) {
            number += tn - scancount;
          }
        }

        this.loading = true;
        var saveBar = []
        var saveERPBar=[]
        if (number > 0) {
          //获取条码
          createGoodsbarcode({number: number}).then(response => {
            if (response.data.code == 0) {
              var codePre = response.data.codepre;
              var num = response.data.num;
              //item.model + item.color + '-' +
              for (let i in this.tableData) {
                var item = this.tableData[i];
                var tn = item.totalnumber | 0;
                var scancount = item.barcodes.length;
                for (let j = 0; j < tn - scancount; j++) {
                  var bc = codePre + this.padleft((num - number + 1).toString(), 3, '0');
                  item.barcodes.push({
                    c: bc
                  });
                  saveBar.push({
                    storegoodsbarcode: bc,
                    cangkucode: '',
                    inordernum: 'allocationbarcode',
                    seedcode: item.seedcode,
                    packagesize: item.packagesize
                  });
                  if (item.unitguid && item.erpserial) {
                    saveERPBar.push({
                      storegoodsbarcode: bc,
                      erpserial: item.erpserial,
                      formtype: '77',
                      detailunitguid: item.unitguid
                    });
                  }
                  number = number - 1;
                }
              }
              batchSave({caiGouRukuData: JSON.stringify(saveBar),erpbarcodes:JSON.stringify(saveERPBar)}).then(resSave => {//保存成功开始打印
                if (resSave.data.code == 0) {
                  this.barcodePDF();
                } else {
                  this.tableData = []
                  this.loading=false
                  this.$message({message: '条码生成失败，请重新选择！', type: 'error'})
                  return;
                }
              })
            }
          });
        } else {
          this.barcodePDF();
        }
      },
      barcodePDF() {
        var barcode = [];
        for (let i in this.tableData) {
          var item = this.tableData[i];
          for (let j in item.barcodes) {
            barcode.push({
              barcode: item.barcodes[j].c, seedcode: item.seedcode, model: item.model, color: item.color
            });
          }
        }
        barcodePrint(barcode, null);
        this.loading = false;
      },
      error(msg) {
        this.$message({
          message: msg,
          type: 'error'
        })
        this.loading = false;
      },
      clearBar(storegoodsbarcode,item) {
        for (let i in item.barcodes) {
          if (item.barcodes[i].c == storegoodsbarcode) {
            item.barcodes.splice(i, 1)
            break;
          }
        }
        if (item.totalnumber > 1)
          item.totalnumber = item.totalnumber - 1;
        this.totalNumber()
      },
      getBarCode() {
        if(!this.checkCanSelect()) {
          this.goodsbarcode = "";
          return;
        }

        if (this.goodsbarcode == '')
          return;
        for (let i in this.tableData) {
          for(let j in this.tableData[i].barcodes){
            if(this.tableData[i].barcodes[j].c==this.goodsbarcode){
              this.error('重复扫码！')
              this.goodsbarcode = '';
              return;
            }
          }
        }
        if (this.goodsbarcode == '')
          return;
        barcodeDetail({storegoodsbarcode: this.goodsbarcode}).then(response => {
          if (response.data.code == 0 && response.data.obj) {
            var arr = response.data.obj;
            if (arr.packagesize.indexOf('"M"') == -1) {
              this.error('非镜架商品！')
              this.goodsbarcode = '';
              return;
            }

            var barcode=this.goodsbarcode;
            this.goodsbarcode = '';
            var pg = JSON.parse(arr.packagesize);

            var hasvalue = false;
            var costprice=0;

            for(let i in this.seedcodeData){
              if (this.seedcodeData[i].seedcode == arr.seedcode) {
                hasvalue = true;
                costprice=this.seedcodeData[i].costprice?this.seedcodeData[i].costprice:0;
                break;
              }
            }
            if(!hasvalue){
              this.goodsbarcode = '';
              this.error('非本品牌商品！')
            }

            hasvalue=false;
            for (let i in this.tableData) {
              if (this.tableData[i].seedcode == arr.seedcode && this.tableData[i].packagesize == arr.packagesize) {
                this.tableData[i].totalnumber = this.tableData[i].totalnumber + 1;
                this.tableData[i].barcodes.push({c: barcode});
                hasvalue = true;
                break;
              }
            }

            if (!hasvalue) {
              if (this.form.seedcode == '') {
                this.form.seedcode = arr.categorycode
                this.form.seedname = arr.seedname.replace(pg.M, '');
              }
              this.tableData.push({
                seedcode: arr.seedcode,
                seedname: arr.seedname,
                color: pg.C,
                model: pg.M,
                categorycode: arr.categorycode,
                totalnumber: 1,
                formproperty: '[{}]',
                packagesize: arr.packagesize,
                costprice:costprice,
                barcodes:[{c:barcode}]
              })
            }

            this.totalNumber()
          } else {
            this.goodsbarcode = '';
            this.error('产品编码不存在！')
          }
        });
      },
      //解除锁定
      unlock() {
        var casestepname = '修改调拨';
        lockremove({
          erpserial: this.erpserial
        }).then(response => {
          if (response.data.code == 0) {
            this.lock = true
            this.uname = ''
            //锁定功能(控制发起采购按钮)
            this.handlelog(casestepname);
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      },
      //回车跳入下一行
      validateCounts(row, index, e) {
        var keyCode = e.keyCode || e.which || e.charCode;
        if (keyCode == 40 || keyCode === 13) {//回车，下方向键
          this.$refs[row.id].blur()
          if (this.tableData.length - 1 === index) {
            index = -1
          }
          this.$refs[Object.keys(this.$refs)[index + 1]].focus();
        } else if (keyCode == 38) {//上方向键
          this.$refs[row.id].blur()
          if (index === 0) {
            index = this.tableData.length
          }
          this.$refs[Object.keys(this.$refs)[index - 1]].focus();
        }
      },
      //删除明细
      handleDelete(index, row) {
        this.tableData.splice(index, 1)
        this.totalNumber()
      },
      //处理日志
      handlelog(casestepname) {
        var handlelog = {}
        handlelog.erpserial = this.form.erpserial
        handlelog.isopen = 1
        if (this.buttonname == '保存') {
          handlelog.casestepname = casestepname
          handlelog.remark = '修改调拨'
        }
        logsaveData(handlelog).then(response => {
        })
      },
      //绑定库存
      bindStore() {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1

        this.storeinfoleft = [];
        this.storeinforight = [];
        this.storeinfo = [];

        getGoodsListWithStoreDetail({
          seedcode: this.form.seedcode,//
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1,
          nolimit:1,
          nodeliverying:1,
          nobuynum:1,
          cangkucode: this.cangkucode,
          calculateStore: "1",
          showyinxing: this.isyinxin? "1" : "0"
        }).then(resStore => {
          if(this.isyinxin) {
            this.tableData = []
          }

          if (resStore.data.obj.length > 0) {
            if(this.isyinxin) {
              resStore.data.obj.forEach(o => {
                let ob = JSON.parse(o.packagesize)
                o.X = ob.X;
                o.Y = ob.Y;
                o.P = o.totalnumber;
                o.totalnumber = undefined;

                if(this.controlData) {
                  var items = this.controlData.seedgooddlist;
                  for (let i in items) {
                    if (JSON.parse(items[i].barcodes).unitguid == o.unitguid) {
                      o.totalnumber = items[i].totalnumber;
                      break;
                    }
                  }
                }
                this.tableData.push(o);//本次调拨的隐形数量
              })
              this.totalNumber();
              this.tableData.sort(function (a, b) {
                let aP = JSON.parse(a.packagesize)
                let bP = JSON.parse(b.packagesize)
                if (aP.X == bP.X) {
                  if(aP.Y=='0.00') aP.Y="-0.00";
                  if(bP.Y=='0.00') bP.Y="-0.00";
                  return aP.Y.localeCompare(bP.Y)
                }
                else {
                  if(aP.X=='0.00') aP.X="-0.00";
                  if(bP.X=='0.00') bP.X="-0.00";
                  return aP.X.localeCompare(bP.X)
                }
              });
              return;
            }

            resStore.data.obj.forEach(o => {
              if (o.packagesize) {
                let ob = JSON.parse(o.packagesize)
                ob.P = o.subtractnum;// - o.deliverying;// + o.transfernum;
                if (ob.type == 'L') {
                  this.storeinfoleft.push(ob);
                } else if (ob.type == "R") {
                  this.storeinforight.push(ob);
                } else {
                  this.storeinfo.push(ob);
                }
              }
            })
          } else {

          }
          this.createPriceBook()
        }).catch((error) => {
          console.log(error)
        });
      },

      getTitle() {
        return this.userInfoModel.tenantname + "调拨单";
      },
      loadFromexcel(){
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },

      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            let arr = []
            console.log(data);
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              let obj = {}
              data.forEach((item) => {
                let Y = ""
                for (let X in item) {
                  obj = {}
                  if (X == "球\\柱") {
                    Y = parseFloat(item[X]).toFixed(2)
                  } else {
                    if (typeof parseFloat(item[X]) === 'number' && !isNaN(parseFloat(item[X]))) {
                      obj = {"X": parseFloat(X).toFixed(2), "Y": Y, "P": Math.abs(parseInt(item[X]))}
                      if (this.type) {
                        obj.type = this.type
                      }
                      arr.push(obj)
                    }
                  }
                }
              })
            }
            this.BookContent = arr
            this.createPriceBook()
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      loadFromBuy(){//从采购单导入
        if (this.cangkucode == this.cangkucode2) {
          this.error('发货仓、收货仓不能选同一个！')
          return false;
        }

        this.$prompt('请输入采购单号', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^32\d{12}$/,
          inputErrorMessage: '采购单号格式不正确'
        }).then(({ value }) => {
          if(value) {
            getJxcformdetailCost({erpserial: value, needdetail: "show"}).then(response => {
              if (response.data.code == 0) {
                var goods = response.data.obj;
                if(goods.length==0)
                  return;

                var filltem=goods[0].filltemplate
                if(this.jinjia == 80&&filltem!='80'){
                  this.$message({
                    message: '请选择镜架类采购单',
                    type: 'info'
                  })
                  return;
                }else  if(this.jinjia != 80&&!(filltem=='10'||filltem=='30')){
                  this.$message({
                    message: '请选择镜片类采购单',
                    type: 'info'
                  })
                  return;
                }

                this.tableData=[]

                if (this.jinjia == 80) {//镜架
                  for(let i in goods) {
                    var pg=JSON.parse(goods[i].packagesize)

                    this.tableData.push({
                      seedcode: goods[i].seedcode,
                      seedname: goods[i].seedname,
                      color:pg.C,
                      model: pg.M,
                      categorycode: goods[i].categorycode,
                      totalnumber: goods[i].totalnumber,
                      formproperty: '[{}]',
                      packagesize:JSON.stringify(pg),
                      costprice:0,
                      barcodes:[]
                    })
                  }

                  if(goods.length>0) {
                    this.jingjiachecktree1(goods[0].categorycode, goods[0].seedname.replace(pg.M, ''), [{attributes: {filltemplate: 80}}],true);
                  }
                } else {
                  this.BookContent = []
                  this.BookContentLeft = []
                  this.BookContentRight = []
                  for (let i in goods) {
                    var pg = JSON.parse(goods[i].packagesize)
                    if (pg.type && pg.type == 'R') {
                      this.BookContentRight.push({X: pg["X"], Y: pg["Y"], type: pg["type"], P: goods[i].totalnumber})
                    } else if (pg.type && pg.type == 'L') {
                      this.BookContentLeft.push({X: pg["X"], Y: pg["Y"], type: pg["type"], P: goods[i].totalnumber})
                    } else {
                      this.BookContent.push({X: pg["X"], Y: pg["Y"], P: goods[i].totalnumber})
                    }
                  }
                  this.checktreeV2(goods[0].seedcode, goods[0].seedname, [{
                    parentId: goods[0].categorycode,
                    attributes: {filltemplate: goods[0].filltemplate}
                  }]);
                }
              }
            })
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });

      },
      //一键补货
      initnum() {
        var seedcode = ''
        if (this.jinjia == 80) {
          if (this.tableData.length == 0) {
            this.$message({
              message: '请先选择镜架具体商品',
              type: 'info'
            })
            return
          } else {
            for (let i in this.tableData) {
              if (i == 0) {
                seedcode = this.tableData[i].seedcode + ','
              } else {
                seedcode = ',' + this.tableData[i].seedcode
              }
            }
          }
        }
        this.BookContent = []
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1
        //收货仓库库存需补货的库存不能大于发货仓库的现有库存
        if (this.form.seedcode) {
          //收货仓库的值，取收货仓库的maxstore
          getGoodsNeedBuy({
              seedcode: this.jinjia == 80 ? seedcode : this.form.seedcode,
              cangkucode: this.cangkucode2,
              minyear: yearnow,
              minmonth: monthnow,
              maxyear: yearnow,
              maxmonth: monthnow,
              nostock: 1,//产品分类（单选）
            },
          ).then(response => {
            var tabledata = response.data.obj
            for (let i in tabledata) {
              if (tabledata[i].maxstore > 0) {
                // console.log(JSON.stringify(tabledata[i]))
              }
            }
            //取发货仓库的当前库存subtractnum
            getGoodsNeedBuy({
                seedcode: this.jinjia == 80 ? seedcode : this.form.seedcode,
                cangkucode: this.cangkucode,
                minyear: yearnow,
                minmonth: monthnow,
                maxyear: yearnow,
                maxmonth: monthnow,
                nostock: 1,//产品分类（单选）
              },
            ).then(response => {
              //左右眼二维表显示
              if (this.filltemplate == 30) {
                for (let j in tabledata) {
                  for (let i in response.data.obj) {
                    if (tabledata[j].packagesize == response.data.obj[i].packagesize) {
                      let subtractnum = response.data.obj[i].subtractnum;// - response.data.obj[i].deliverying;//发货仓 需要扣除待发货的数量
                      let num = tabledata[j].maxstore > subtractnum ? subtractnum : tabledata[j].maxstore

                      if (JSON.parse(response.data.obj[i].packagesize)["type"] == "L") {
                        this.BookContentLeft.push({
                          X: JSON.parse(response.data.obj[i].packagesize)["X"],
                          Y: JSON.parse(response.data.obj[i].packagesize)["Y"],
                          type: JSON.parse(response.data.obj[i].packagesize)["type"],
                          P: num <= 0 ? '' : num,
                        })
                        break
                      } else {
                        this.BookContentRight.push({
                          X: JSON.parse(response.data.obj[i].packagesize)["X"],
                          Y: JSON.parse(response.data.obj[i].packagesize)["Y"],
                          type: JSON.parse(response.data.obj[i].packagesize)["type"],
                          P: num <= 0 ? '' : num,
                        })
                      }
                      break
                    }
                  }
                }
              } else if (this.jinjia == 80) {
                for (let j in tabledata) {
                  for (let i in response.data.obj) {
                    if (tabledata[j].seedcode == response.data.obj[i].seedcode&&tabledata[j].packagesize == response.data.obj[i].packagesize) {
                      let subtractnum = response.data.obj[i].subtractnum;// - response.data.obj[i].deliverying;//发货仓 需要扣除待发货的数量
                      let num = tabledata[j].maxstore > subtractnum ? subtractnum : tabledata[j].maxstore
                      tabledata[j].totalnumber = num
                      break
                    }
                  }
                }
              } else {
                for (let j in tabledata) {
                  for (let i in response.data.obj) {
                    if (tabledata[j].packagesize == response.data.obj[i].packagesize) {
                      let subtractnum = response.data.obj[i].subtractnum;// - response.data.obj[i].deliverying;//发货仓 需要扣除待发货的数量
                      let num = tabledata[j].maxstore > subtractnum ? subtractnum : tabledata[j].maxstore
                      this.BookContent.push({
                        X: JSON.parse(response.data.obj[i].packagesize)["X"],
                        Y: JSON.parse(response.data.obj[i].packagesize)["Y"],
                        P: num <= 0 ? '' : num,
                      })
                      break
                    }
                  }
                }
              }
              if (this.jinjia != 80)
                this.getXYRange()
            })
          })
        } else {
          this.$message({
            message: '请选择货品',
            type: 'info'
          })
        }
      },
      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      },
      checktree1(guids, names, arr) {
        this.BookContent = []
        this.BookContentLeft=[]
        this.BookContentRight=[]
        this.checktreeV2(guids, names, arr);
      },
      checktreeV2(guids, names, arr) {
        this.form.seedcode = guids
        this.form.seedname = names
        this.filltemplate = arr[0].attributes.filltemplate
        this.costpricebook = {}
        this.categorycode = arr[0].parentId;

        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
        if (this.filltemplate == '30') {//左右眼
          this.showzuoyoutable = true
          this.showerweitable = false
          this.shownumber = false
        } else {
          if (this.filltemplate == '40') {//数量类型
            this.showzuoyoutable = false;
            this.showerweitable = false;
            this.shownumber = true;
            return;
          } else {
            this.showzuoyoutable = false
            this.showerweitable = true
            this.shownumber = false
          }
        }
        if (this.form.seedname == "") {
          this.$message({
            message: '请选择货品',
            type: 'warning'
          })
          return
        }
        //比对已选数据
        for (let i = 0; i < this.seedgoods.length; i++) {
          if (this.seedgoods[i].seedcode == this.form.seedcode) {
            this.BookContent = this.seedgoods[i].BookContent
            this.index = i
            break
          }
        }

        this.isyinxin=this.categorycode.startsWith("010");
        if (this.isyinxin) {
          listCert({offset: 0, limit: 1, certtype: 1, seedcode: this.form.seedcode}).then(response => {
            if (!(response.data.code == 0 && response.data.obj.rows.length > 0)) {
              this.isyinxin=false;
            }
            this.getXYRange();
          })
        } else {
          this.getXYRange();
        }
      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1,filltemplates:'10;30'})
        })
      },
      jingjiachecktree1(guids, names, arr,noselect) {
        this.seedcodeData = []
        if (guids.length < 9) {
          this.$message.error('请选择品牌或系列!');
          this.$refs.treeSeedleibie.reset();
          return;
        }

        this.form.seedcode = guids
        this.form.seedname = names
        // this.form.seedinfo = ";" + guids + "," + arr[0].parentId + ";"
        this.filltemplate = arr[0].attributes.filltemplate

        if (this.form.seedname == "") {
          this.$message({
            message: '请选择类别',
            type: 'warning'
          })
          return
        }
        listgoodsframe({
          categorycode: this.form.seedcode,
          filltemplate: '80',
        }).then(response => {
          this.seedcodeData = response.data.obj
          if (this.seedcodeData.length > 0) {
            //参数  true 显示库存，seedcode分类，cangkucode 发货仓库，seedcodeData 分类下的商品
            if (!noselect) {
              if (this.seedcodeData.length == 1 && (!this.seedcodeData[0].color || this.seedcodeData[0].color.indexOf(';') == -1)) {//单型号、单色号 直接加一条商品
                var oneRow = this.seedcodeData[0];
                this.afterSelectADD([{
                  seedcode: oneRow.seedcode,
                  seedname: oneRow.seedname,
                  categorycode: oneRow.categorycode,
                  P: 1,
                  M: oneRow.model,
                  C: oneRow.color
                }]);
                this.totalNumber();
              } else {
                this.addFrame();
              }
              //this.$refs.batchBuyFormProperties.initData(true, this.form.seedcode, this.cangkucode, this.seedcodeData, "");
            }else{
              //从采购单导入的
              for (let i in this.tableData) {
                for (let j in this.seedcodeData) {
                  if (this.seedcodeData[j].seedcode == this.tableData[i].seedcode) {
                    this.tableData[i].costprice = this.seedcodeData[j].costprice ? this.seedcodeData[j].costprice : 0;
                    break;
                  }
                }
              }
            }
          } else {
            return
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      //商品树
      jinjiabindData() {
        this.$refs.treeSeedleibie.bindData(() => {
          return getGoodsTree({onlyShowGroupType:true,categorystarts:'002;003;005;004;006'})
        })

      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.checkCanSelect()) {
          for (let i in this.seedcodeData) {
            this.seedcodeData[i].totalnumber = 0
          }
          //参数  true 显示库存，seedcode分类，cangkucode 发货仓库，seedcodeData 分类下的商品
          this.$refs.batchBuyFormProperties.initData(true, this.form.seedcode, this.cangkucode, this.seedcodeData, "")
        }
      },
      //给tableData 添加 id，共回车使用
      indexMethod(index) {
        this.tableData[index].id = index
        return index + 1;
      },
      getXYRange() {
        this.storeinfoleft = [];
        this.storeinforight = [];
        this.storeinfo = [];
        getPrice({
          seedcode: this.form.seedcode,
          filterType: 'cost'
        }).then((response) => {
          if (response.data.code == 0 && response.data.obj) {
            this.costpricebook = response.data.obj
          } else {
            this.costpricebook = {}
          }
          // if (this.userInfoModel.independentserial == "" || this.independentserial == this.userInfoModel.independentserial) {
            if (this.form.seedcode) {
              this.bindStore()
            }
          // } else {
          //   this.createPriceBook()
          // }
        })
      },
      afterSelectADD(arr){
        for (var i in arr) {
          var hasValue = false;
          for (var j in this.tableData) {
            if (this.tableData[j].seedcode == arr[i].seedcode && this.tableData[j].model == arr[i].M && this.tableData[j].color == arr[i].C)
            {//在库存里的
              this.tableData[j].totalnumber+=arr[i].P;
              hasValue = true
              break;
            }
          }
          if (!hasValue) {
            this.tableData.push({
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              color:arr[i].C,
              model:arr[i].M,
              categorycode: '',
              totalnumber: arr[i].P,
              formproperty: '[{}]',
              packagesize:'{"M":"'+arr[i].M+'","C":"'+arr[i].C+'"}',
              costprice:arr[i].costprice,
              barcodes:[]
            })
          }
        }
        this.sortTable();
        this.totalNumber();
      },
      sortTable(){
        //从小到大排序
        this.tableData.sort(function (a, b){
          if (a.model == b.model)
            return a.color.localeCompare(b.color);
          else
            return a.model.localeCompare(b.model);
        });
      },
      //选择商品之后执行
      afterSelectCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            //判读该商品是否属于
            if (this.tableData[j].seedcode == arr[i].seedcode && this.tableData[j].model == arr[i].model && this.tableData[j].color == arr[i].color)
            {
              biaoji = 1
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              color:arr[i].color,
              model:arr[i].model,
              categorycode: arr[i].categorycode,
              totalnumber: arr[i].totalnumber,
              formproperty: '[{}]',
              packagesize:'{"M":"'+arr[i].model+'","C":"'+arr[i].color+'"}',
              costprice:arr[i].costprice,
              barcodes:[]
            })
          }
        }
       this.sortTable();

        this.totalNumber()
        if (count > 0) {
          this.$message({
            message: "商品已存在！",
            type: 'info'
          })
        }

      },
      reload() {
        this.isRouterAlive = false
        this.$nextTick(() => (this.isRouterAlive = true))
      },
      //购买总数
      totalNumber() {
        this.totalnumber = 0
        for (let i in this.tableData) {
          if(this.tableData[i].totalnumber==undefined)
            continue;
          var num = parseInt(this.tableData[i].totalnumber);
          this.totalnumber = this.totalnumber + num
        }
      },
      createPriceBook() {
        console.log(this.storeinfo)
        if (this.filltemplate == 30) {
          this.$refs.referweibiaoleft.initBook(this.costpricebook, this.BookContentLeft, '', this.storeinfoleft)
          this.$refs.referweibiaoright.initBook(this.costpricebook, this.BookContentRight, '', this.storeinforight)
        } else {
          this.$refs.referweibiao.initBook(this.costpricebook, this.BookContent, '', this.storeinfo)
        }
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      print1() {
        // window.print()
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)

          this.showtitle1 = "none"
        })
      },
      show(item) {
        this.dialogSeeVisible = true;
      },
      changesend(val) {
        for (let i in this.jxcstoreDatasend) {
          if (this.jxcstoreDatasend[i].cangkucode == val) {
            this.cangkuname = this.jxcstoreDatasend[i].cangkuname;
            this.addresssend = this.jxcstoreDatasend[i].address
            this.linktelsend = this.jxcstoreDatasend[i].tel
            this.independentserial = this.jxcstoreDatasend[i].independentserial
            // if ((this.jxcstoreDatasend[i].independentserial == this.userInfoModel.independentserial) || this.userInfoModel.independentserial == "") {
            if (this.form.seedcode) {
              this.bindStore()
            }
            // } else {
            //   this.storeinfoleft = [];
            //   this.storeinforight = [];
            //   this.storeinfo = [];
            //   this.getXYRange()
            // }
          }
        }
      },
      changereceive(val) {
        for (let i in this.jxcstoreDatareceive) {
          if (this.jxcstoreDatareceive[i].cangkucode == val) {
            this.cangkuname2 = this.jxcstoreDatareceive[i].cangkuname
            this.addressreceive = this.jxcstoreDatareceive[i].address
            this.linktelreceive = this.jxcstoreDatareceive[i].tel
          }
        }
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      }
      ,
      errorMessag(msg) {
        this.$message({
          message: msg,
          type: 'warning'
        })
        this.loading = false;
      },
      saveData() {
        //取出对应的表单详情和数量
        var arr = [];
        if (this.jinjia == 80) {//镜架调拨
          for (let i in this.tableData) {
            var obj = {}
            obj.seedcode = this.tableData[i].seedcode
            obj.packagesize = this.tableData[i].packagesize
            obj.seedname = this.tableData[i].seedname
            obj.categorycode = this.tableData[i].categorycode
            var barcodes=''
            for(let j in this.tableData[i].barcodes){
              barcodes+=this.tableData[i].barcodes[j].c+';';
            }

            if (this.tableData[i].barcodes.length>parseInt(this.tableData[i].totalnumber)) {
              this.error('填写的数量不能小于条码数量！');
              return;
            }

            obj.barcodes = barcodes
            if (parseInt(this.tableData[i].totalnumber) !== 0) {
              obj.P = this.tableData[i].totalnumber
              arr.push(obj)
            }
          }
        } else if (this.filltemplate == "30") {//左右眼
          for (let i in   this.erweitableleft) {
            let temp = this.erweitableleft[i].filter((t) => {
              t.type = "L"
              return typeof(t.P) != "undefined" && t.P !== ""&& parseInt(t.P) !== 0;
            })
            arr = arr.concat(temp)
          }
          for (let i in   this.erweitableright) {
            let temp = this.erweitableright[i].filter((t) => {
              t.type = "R"
              return typeof(t.P) != "undefined" && t.P !== ""&& parseInt(t.P) !== 0;
            })
            arr = arr.concat(temp)
          }
        }
        else {//非左右眼
            if (this.shownumber) {
              if (this.totalnumber > 0) {
                var obj = {}
                obj.seedcode = this.form.seedcode
                obj.seedname = this.form.seedname
                obj.P = this.totalnumber
                arr.push(obj)
              }
            } else {
              if(this.isyinxin){//隐形

                for (let i in this.tableData) {
                  var obj = {}
                  if (parseInt(this.tableData[i].totalnumber) > 0) {
                    obj.packagesize = this.tableData[i].packagesize
                    obj.barcodes = this.tableData[i].unitguid;
                    obj.P = this.tableData[i].totalnumber
                    arr.push(obj)
                  }
                }

              }else {
                for (let i in   this.erweitable) {
                  let temp = this.erweitable[i].filter((t) => {
                    return typeof(t.P) != "undefined" && t.P !== "" && parseInt(t.P) !== 0;
                  })
                  arr = arr.concat(temp)
                }
              }
            }
          }
        if (arr.length == 0) {
          this.errorMessag('请填写调拨数量！')
          return
        }

        if (!this.cangkucode) {
          this.errorMessag('请选择发货仓库！')
          return
        }

        if (!this.cangkucode2) {
          this.errorMessag('请选择收货仓库！')
          return
        }

        if (this.cangkucode == this.cangkucode2) {
          this.errorMessag('发货仓库、收货仓库不能相同！')
          return
        }
        if (this.cangkucode.indexOf('@')>-1&&this.cangkucode2.indexOf('@')>-1) {
          this.errorMessag('发货仓库、收货仓库不能都选其他店！')
          return
        }
        if (arr.length != 0) {
          let jxcformdetails = [];
          if (this.jinjia == 80) {
            for (let i in arr) {
              jxcformdetails.push(
                {
                  seedcode: arr[i].seedcode,
                  seedname: arr[i].seedname,
                  categorycode: arr[i].categorycode,
                  packagesize: arr[i].packagesize,
                  totalnumber: arr[i]["P"],
                  barcodes: arr[i].barcodes,
                }
              )
            }
          } else if (this.shownumber) {
            jxcformdetails.push(
              {
                seedcode: this.form.seedcode,
                seedname: this.form.seedname,
                totalnumber: this.totalnumber
              }
            )
          } else {
            if (this.isyinxin) {
              for (let i in arr) {
                jxcformdetails.push(
                  {
                    seedcode: this.form.seedcode,
                    seedname: this.form.seedname,
                    categorycode: this.categorycode,
                    totalnumber: arr[i]["P"],
                    packagesize: arr[i]["packagesize"],
                    barcodes: arr[i]["barcodes"],
                  }
                )
              }
            } else {
              for (let i in arr) {
                let packsize = {};
                packsize = {
                  X: arr[i]["X"].toFixed(2) + "",
                  Y: arr[i]["Y"].toFixed(2) + ""
                }
                if (this.filltemplate == "30") {
                  packsize["type"] = arr[i].type
                }
                jxcformdetails.push(
                  {
                    seedcode: this.form.seedcode,
                    seedname: this.form.seedname,
                    categorycode: this.categorycode,
                    totalnumber: arr[i]["P"],
                    packagesize: packsize
                  }
                )
              }
            }
            // this.seedinfo=this.form.seedname+','+this.form.seedcode
          }
          saveData({
            unitguid: this.unitguid,
            seedgoods: JSON.stringify(jxcformdetails),
            cangkucode: this.cangkucode,
            cangkuname: this.cangkuname,
            cangkucode2: this.cangkucode2,
            cangkuname2: this.cangkuname2,
            remark: this.remark,
            seedcode: this.form.seedcode,
            seedname: this.form.seedname,
            updatecz: this.updatecz,
            logisticsco: this.logisticsco,
            logisticsnum: this.logisticsnum,
            seedinfo: this.seedinfo,
            categorycode: this.categorycode,
            erpserial: this.form.erpserial,
            filltemplate: this.jinjia == 80 ? 80 : "",
            casestatus: this.isyinxin ? 100 : 0
          }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '保存成功，等待' + this.cangkuname + '发货。',
                type: 'success'
              })
              this.$emit('bindGrid', this.buttonname == '通过');
            } else {
              this.errorMessag(response.data.msg)
            }
            this.dialogSeeVisible = false;
            //刷新列表
          });
          //
        } else {
          this.errorMessag('请填写调拨单明细！')
        }
      } ,
      //查看采购单
      // lookbuyorderdetail(row, isbuyorder) {
      //   this.$refs.BuyorderDetail.initData(row, isbuyorder)
      //   this.$refs.BuyorderDetail.show();
      // },
      initData(item, isupdate, filltemplate) {
        this.initForm()
        this.jinjia = filltemplate//等于40时 才是镜架镜架调拨
        this.reload()
        //通过isupdate判读是否是进行修改的操作
        if (isupdate && isupdate == 1) {
          this.isupdate = true
          this.updatecz = 1
          this.unitguid = item.unitguid
          getDetail({unitguid: item.unitguid}).then(response => {
            if(response.data.obj.tenantid!=this.userInfoModel.tenantid) {//不是本门店的订单，需要修改
              response.data.obj.cangkucode = response.data.obj.tenantid + '@' + response.data.obj.cangkucode;
              response.data.obj.cangkucode2 = response.data.obj.cangkucode2.split('@')[1];
            }
            this.controlData = response.data.obj;
            if (this.controlData.status == -20 && !this.userInfoModel.independentserial) {//总部订单岗审核
              this.buttonname = '通过'
            }
            this.form.erpserial = response.data.obj.erpserial;
            if (this.controlData.filltemplate == 40){//数量类型
              this.showzuoyoutable = false
              this.shownumber = true
              this.showerweitable = false
              this.totalnumber=this.controlData.seedgooddlist[0].totalnumber
              this.form.seedcode = this.controlData.seedgooddlist[0].seedcode
              this.form.seedname = this.controlData.seedgooddlist[0].seedname
            }else if (this.controlData.filltemplate == 80) {//镜架 调拨
              this.jinjia = this.controlData.filltemplate
              this.form.seedcode = this.controlData.seedcode
              this.form.seedname = this.controlData.seedname
              for (let i in this.controlData.seedgooddlist) {
                var row = this.controlData.seedgooddlist[i];
                var pack = JSON.parse(row.packagesize)
                var bc = []
                if (row.barcodes) {
                  var bcSpl=row.barcodes.split(';');
                  for (let s in bcSpl) {
                    if (bcSpl[s])
                      bc.push({c: bcSpl[s]});
                  }
                }
                this.tableData.push({
                  seedcode: row.seedcode,
                  seedname: row.seedname,
                  color: pack.C,
                  model: pack.M,
                  categorycode: this.controlData.seedcode,
                  totalnumber: row.totalnumber,
                  formproperty: '[{}]',
                  packagesize: row.packagesize,
                  barcodes: bc,
                  unitguid:row.unitguid,
                  erpserial:row.erpserial,
                })
              }
              this.totalNumber()
              listgoodsframe({
                categorycode: this.form.seedcode,
                filltemplate: '80',
              }).then(response => {
                this.seedcodeData = response.data.obj
              });

            } else {
              this.form.seedcode = this.controlData.seedgooddlist[0].seedcode
              this.form.seedname = this.controlData.seedgooddlist[0].seedname

              if(this.controlData.seedgooddlist[0].categorycode.startsWith("010")&&this.controlData.barcodes&&this.controlData.barcodes.length>0){
                this.isyinxin=true;
              }
              if (this.controlData.bookcontent[0]["type"]) {
                this.showzuoyoutable = true
                this.showerweitable = false
                this.shownumber=false
                this.filltemplate = 30
              } else {
                  this.showzuoyoutable = false
                  this.shownumber = false
                  this.showerweitable = true
              }
              var bookcontent = this.controlData.bookcontent
              if (this.showzuoyoutable) {
                for (let i in bookcontent) {
                  if (bookcontent[i].type == "L") {
                    this.BookContentLeft.push(bookcontent[i])
                  }
                  if (bookcontent[i].type == "R") {
                    this.BookContentRight.push(bookcontent[i])
                  }
                }
              }
              if (this.showerweitable) {
                this.BookContent = bookcontent
              }
            }
            this.cangkucode = this.controlData.cangkucode
            this.cangkuname = this.controlData.cangkuname
            this.cangkucode2 = this.controlData.cangkucode2
            this.cangkuname2 = this.controlData.cangkuname2

            getListDataall({showother:1}).then(response => {
              this.jxcstoreDatasend = response.data.obj
              for (let i in this.jxcstoreDatasend) {
                if (this.jxcstoreDatasend[i].independentserial = this.controlData.cangkucode) {
                  this.independentserial = this.jxcstoreDatasend[i].independentserial
                }
              }
              this.jxcstoreDatareceive = response.data.obj
            })

            this.remark = JSON.parse(this.controlData.remark)[0].msg
            //判断是否有成本价
            if(this.showerweitable||this.showzuoyoutable)
               this.getXYRange()
            //查询订单是否有人正在操作
            if (this.buttonname == '保存') {

            }
          });
        } else {
          this.getXYRange()
          getListDataall({showother:1}).then(response => {
            this.jxcstoreDatasend = response.data.obj
            this.independentserial = this.jxcstoreDatasend[0].independentserial
            this.cangkucode = this.jxcstoreDatasend[0].cangkucode
            this.cangkuname = this.jxcstoreDatasend[0].cangkuname
            this.addresssend = this.jxcstoreDatasend[0].address
            this.linktelsend = this.jxcstoreDatasend[0].tel

            this.jxcstoreDatareceive = response.data.obj
            if (item) {
              this.form.seedcode = item.seedcode
              this.form.seedname = item.seedname
              this.cangkucode2 = item.cangkucode
              this.cangkuname2 = item.cangkuname
              this.addressreceive = ''
              this.linktelreceive = ''
              this.filltemplate = item.filltemplate
              if (item.filltemplate == 30) {
                this.showzuoyoutable = true,
                  this.showerweitable = false
              } else {
                this.showzuoyoutable = false,
                  this.showerweitable = true
              }
              this.getXYRange()
              this.initnum()
            } else {
              var storeInfo = this.jxcstoreDatareceive[0];
              if (this.userInfoModel.independentserial) {
                for (let i in this.jxcstoreDatareceive) {
                  if (this.jxcstoreDatareceive[i].independentserial == this.userInfoModel.independentserial) {
                    storeInfo = this.jxcstoreDatareceive[i];
                    break;
                  }
                }
              }
              this.cangkucode2 = storeInfo.cangkucode
              this.cangkuname2 = storeInfo.cangkuname
              this.addressreceive = storeInfo.address
              this.linktelreceive = storeInfo.tel
            }
          })

        }
      },
      initForm() {
        this.loading = false;
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.buttonname = '保存'
        this.controlData=null
        this.erweitable = []
        this.isyinxin=false;
        this.BookContent = []
        this.form.seedcode = ""
        this.form.seedname = ''
        this.tableData1 = []
        this.remark = ''
        this.filltemplate = ''
        this.BookContentRight = []
        this.BookContentLeft = []
        this.cangkucode = ''
        this.cangkuname = ''
        this.cangkucode2 = ''
        this.cangkuname2 = ''
        this.isupdate = false
        this.showerweitable = false
        this.showzuoyoutable = false
        this.shownumber = false
        this.updatecz = 0
        this.seedinfo = ''
        this.logisticsco = ''
        this.categorycode = ''
        this.storeinfo = []
        this.storeinfoleft = []
        this.storeinforight = []
        this.uname = ''
        this.lock = true
        this.jinjia = ''
        this.seedcodeData = []
        this.tableData = []
        this.totalnumber = 0
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))

      //切换仓库时调用
      window.refreshErWeiTable = () => {
        this.storeinfo = []
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.jinjia != 80)
          this.getXYRange()
      }
      // getParameterDetail({paraname: "快递公司"}).then(response => {
      //   this.parameterData = JSON.parse(response.data.obj.paracontent);
      //   this.logisticsco = this.parameterData[0].name
      // })
    },
    components: {
      TwoDimensionalTable,
      BatchBuyFormProperties,
      MakeInventoryFrameAdd
      //BuyorderDetail
    }
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/warehouse/AllocationEditNew.vue